var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgCardAgeing = function SvgCardAgeing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.565 5.27a.992.992 0 0 0 .66-.245.796.796 0 0 0 .274-.592v-.56a.79.79 0 0 0-.26-.616.99.99 0 0 0-.674-.257H5.437a.992.992 0 0 0-.663.248.796.796 0 0 0-.271.597v.56c0 .223.098.436.273.593a.993.993 0 0 0 .661.245c0 3.192 2 5.878 4.726 6.73-2.726.85-4.726 3.537-4.726 6.728-.516 0-.934.376-.934.838v.56c-.02.231.068.459.242.629.174.17.419.269.676.272H18.55c.249 0 .488-.09.663-.248a.796.796 0 0 0 .271-.597v-.56a.796.796 0 0 0-.274-.593.993.993 0 0 0-.66-.245c0-3.192-2-5.878-4.726-6.73 2.74-.879 4.741-3.565 4.741-6.756Zm-6.572 5.048c-2.262 0-4.07-2.333-4.07-5.047h8.14c0 2.734-1.822 5.047-4.07 5.047Z",
    fill: "#262D38",
    fillOpacity: 0.3
  })));
};

export default SvgCardAgeing;